import React, { Component } from "react";
import { getRequest } from "../../api/ApiService";
import { logError } from "../../services/utils";
import AbbreviatedMillionNumberFormat from "../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class ResultsPanelIncomeStatement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gross_profit: {},
      total_operating_costs: {},
      net_income: {},
      roundInUrl: props.roundInUrl
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  getIncomeStatement() {
    const base_url = `${process.env.REACT_APP_API_URL}team/report/income_statement/`;
    let url = `${base_url}?round_lte=${this.props.currentRound}`;
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.props.currentRound
    ) {
      url = `${base_url}?round_lte=${this.state.roundInUrl}`;
    }

    return getRequest(url);
  }

  fetchData() {
    this.getIncomeStatement()
      .then(res => {
        let gross_profit = {};
        let total_operating_costs = {};
        let net_income = {};

        res.body.forEach(item => {
          let round_id = item.round;
          let round = this.props.rounds.find(i => i.id === round_id);
          let round_number = round.number;

          if (item["Gross Profit"]) {
            gross_profit[round_number] = item["Gross Profit"];
          }

          if (item["Total Operating Costs"]) {
            total_operating_costs[round_number] = item["Total Operating Costs"];
          }

          if (item["Net Income"]) {
            net_income[round_number] = item["Net Income"];
          }
        });

        this.setState({
          gross_profit,
          total_operating_costs,
          net_income
        });
      })
      .catch(err => {
        logError(err, "ResultsPanelIncomeStatement", "fetchData");
      });
  }

  componentDidMount() {
    this.fetchData();
  }

  getYear(offset) {
    const { currentRound } = this.props;
    const { roundInUrl } = this.state;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    let rounds = [current_round, current_round + 1, current_round + 2];
    if (current_round + 2 > this.props.rounds.length) {
      current_round = this.props.rounds[this.props.rounds.length - 1].number;
      rounds = [current_round - 2, current_round - 1, current_round];
    }

    return rounds[offset];
  }

  get year1() {
    return this.getYear(0);
  }

  get year2() {
    return this.getYear(1);
  }

  get year3() {
    return this.getYear(2);
  }

  getDataValue(key, year) {
    if (key in this.state) {
      let data = this.state[key];
      if (year in data) {
        return data[year];
      }
    }

    return 0;
  }

  getGrossProfit(year) {
    return this.getDataValue("gross_profit", year);
  }

  get grossProfit1() {
    return this.getGrossProfit(this.year1);
  }

  get grossProfit2() {
    return this.getGrossProfit(this.year2);
  }

  get grossProfit3() {
    return this.getGrossProfit(this.year3);
  }

  getOperatingProfit(year) {
    return (
      this.getGrossProfit(year) +
      this.getDataValue("total_operating_costs", year)
    );
  }

  get operatingProfit1() {
    return this.getOperatingProfit(this.year1);
  }

  get operatingProfit2() {
    return this.getOperatingProfit(this.year2);
  }

  get operatingProfit3() {
    return this.getOperatingProfit(this.year3);
  }

  getNetIncome(year) {
    return this.getDataValue("net_income", year);
  }

  get netIncome1() {
    return this.getNetIncome(this.year1);
  }

  get netIncome2() {
    return this.getNetIncome(this.year2);
  }

  get netIncome3() {
    return this.getNetIncome(this.year3);
  }

  render() {
    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th className="table-title text-center">
                <span></span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year1}</span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year2}</span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year3}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <th className="text-left">Gross Profits</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.grossProfit1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.grossProfit2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.grossProfit3}
                  prefix="$"
                />
              </td>
            </tr>
            <tr className="text-center">
              <th className="text-left">Operating Profits</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.operatingProfit1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.operatingProfit2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.operatingProfit3}
                  prefix="$"
                />
              </td>
            </tr>
            <tr className="text-center">
              <th className="text-left">Net Profits</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.netIncome1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.netIncome2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.netIncome3}
                  prefix="$"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ResultsPanelIncomeStatement;



// WEBPACK FOOTER //
// ./src/components/results/ResultsPanelIncomeStatement.js